import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';

import clsx from 'clsx';
import moment from 'moment';

import BobActionMenu from '../../../../components/BobActionMenu';

import * as BasAgentActions from '../../../../actions/basAgentActions';

import * as classes from './AgentDetailsPanel.module.css';

const AgentDetailsPanel = ({
    history,
    pingBasAgent,
    rebootAgent,
    restartAgentApplication,
    setRenameAgentModalOpen,
    setAssignAgentModalOpen,
    setDeleteAgentModalOpen,
    setFactoryResetAgentModalOpen,
    selectedAgent,
    ...props
}) => {

    const renderStatus = agent => {
        const status = agent.connected;

        if (status === true) {
            return (
                <span><i className={clsx('far fa-check-circle fa-lg', classes.Connected)} /> Connected</span>
            );
        } else if (status === false) {
            return (
                <span><i className={clsx('far fa-times-circle fa-lg', classes.Disconnected)} /> Disconnected</span>
            );
        } else {
            return (
                <span><i className={clsx('fas fa-minus-circle fa-lg', classes.NotAvailable)} /> Not Available</span>
            );
        }
    };

    const renderCurrentLoad = () => {
        const load = selectedAgent.driverConfiguration ? selectedAgent.driverConfiguration[0].currentLoad : 0;
        return `${load.toFixed(2)}%`;
    };

    const renderModifiedOn = () => {
        const modifiedOn = new Date(selectedAgent.modifiedOn);
        return moment(modifiedOn).format('DD-MM-YY HH:mm A');
    };

    const handleConfigureAgent = () => {
        const path = '/v2/dashboard/iothub/configure';
        const queryValues = queryString.parse(history.location.search);
        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);
    };

    const handlePingAgent = () => {
        pingBasAgent(selectedAgent.id);
    };

    const handleRebootAgent = () => {
        rebootAgent(selectedAgent.id);
    };

    const handleRestartApplication = () => {
        restartAgentApplication(selectedAgent.id);
    };

    return (
        <div className={classes.AgentDetailsPanel}>
            <div className={classes.PanelHeader}>
                <span className={classes.Title}>Agent Details</span>
                <span className={classes.ActionButton}>
                    <BobActionMenu
                        activeTab={'AgentActions'}
                        handlePingAgent={handlePingAgent}
                        handleConfigureAgent={handleConfigureAgent}
                        handleRebootAgent={handleRebootAgent}
                        handleRestartApplication={handleRestartApplication}
                        setRenameAgentModalOpen={setRenameAgentModalOpen}
                        setAssignAgentModalOpen={setAssignAgentModalOpen}
                        setDeleteAgentModalOpen={setDeleteAgentModalOpen}
                        setFactoryResetAgentModalOpen={setFactoryResetAgentModalOpen}
                    />
                </span>
            </div>
            <div className={classes.Label}>
                Name
            </div>
            <div className={classes.Value}>
                {selectedAgent.name}
            </div>
            <div className={classes.Label}>
                Serial Number
            </div>
            <div className={classes.Value}>
                {selectedAgent.serialNumber || 'No Agent Assigned'}
            </div>
            <div className={classes.Label}>
                Connection Status
            </div>
            <div className={classes.Value}>
                {renderStatus(selectedAgent)}
            </div>
            <div className={classes.Label}>
                Firmware
            </div>
            <div className={classes.Value}>
                {selectedAgent.firmwareVersion || 'Not Available'}
            </div>
            <div className={classes.Label}>
                Deployment
            </div>
            <div className={classes.Value}>
                {selectedAgent.deployment}
            </div>
            <div className={classes.Label}>
                BAS Driver
            </div>
            <div className={classes.Value}>
                {selectedAgent.driverConfiguration ? selectedAgent.driverConfiguration[0].basType : null}
            </div>
            <div className={classes.Label}>
                Average BAS Load
            </div>
            <div className={classes.Value}>
                {renderCurrentLoad()}
            </div>
            <div className={classes.Label}>
                Time Zone
            </div>
            <div className={classes.Value}>
                {selectedAgent.timeZone}
            </div>
            <div className={classes.Label}>
                Latest Inventory Date
            </div>
            <div className={classes.Value}>
                {renderModifiedOn()}
            </div>
        </div>
    );
};

const mapDispatchToProps = {
    ...BasAgentActions
};

export default withRouter(connect(null, mapDispatchToProps)(AgentDetailsPanel));
